import { Components } from "@mui/material/styles";

export const MuiMenu: Components['MuiMenu'] = {
    styleOverrides: {
        root: {
            borderRadius: 'unset',
            '& .MuiPaper-root': {
                borderRadius: 'unset'
            }
        }
    }
};
